'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _AlbumsItemsGroup = require('../AlbumsItemsGroup/AlbumsItemsGroup');

var _AlbumsItemsGroup2 = _interopRequireDefault(_AlbumsItemsGroup);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlbumsItemsGroups = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(AlbumsItemsGroups, _PureComponent);

  function AlbumsItemsGroups() {
    (0, _classCallCheck3.default)(this, AlbumsItemsGroups);
    return (0, _possibleConstructorReturn3.default)(this, (AlbumsItemsGroups.__proto__ || (0, _getPrototypeOf2.default)(AlbumsItemsGroups)).apply(this, arguments));
  }

  (0, _createClass3.default)(AlbumsItemsGroups, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          albums = _props.albums,
          tracks = _props.tracks,
          loading = _props.loading,
          showTitles = _props.showTitles;


      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)({ 'margin-top-30 row': !showTitles }) },
        albums.map(function (albumsGroup) {
          return _react2.default.createElement(_AlbumsItemsGroup2.default, {
            key: albumsGroup.id,
            albumsGroup: albumsGroup,
            tracks: tracks,
            showTitles: showTitles
          });
        }),
        _react2.default.createElement(_components.Loader, { show: loading, alignCenter: true })
      );
    }
  }]);
  return AlbumsItemsGroups;
}(_react.PureComponent), _class.propTypes = {
  albums: _propTypes2.default.array,
  loading: _propTypes2.default.bool,
  showTitles: _propTypes2.default.bool,
  tracks: _propTypes2.default.object
}, _class.defaultProps = {
  albums: [],
  tracks: {}
}, _temp);
exports.default = AlbumsItemsGroups;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AlbumsItems/AlbumsItemsGroups/AlbumsItemsGroups.js
// module id = 1950
// module chunks = 1